import './AnimalCard.css'
import useCollapse from 'react-collapsed'
import ReactMarkdown from 'react-markdown'
import { useState } from 'react'

import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

// goal: make 2 versions, expanded and unexpanded
// ability to sort cards
// ability to hover over rarity score to see more info (or click)


function rarity(rarScore){
    let rarStr;
    if (rarScore === 1){
        rarStr = "Very common! Expect to encounter around campus.";
    }else if(rarScore === 2){
        rarStr = "Less common, but you can find them if you're looking.";
    }else if(rarScore === 3){
        rarStr = "Rare, unlikely to be observed without a Foothills Permit";
    }
    return rarStr;
}

function threatened(threatBool){
    if (threatBool){
        return "Threatened";
    }else{
        return "Not threatened";
    }
}



export default function AnimalCard(props) {
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse();
    const [ highlighted, setHighlighted ] = useState(null);

    console.log(props.data);
    return(
        <div className="card" style={{ backgroundColor: highlighted==="card" ? "#cdc7c1": "#E7E1DB"}} {...getToggleProps()} onMouseEnter={() => setHighlighted("card")} onMouseLeave={() => setHighlighted(null)}>
            <div className="minimizedContent">
                <div className="image1container">
                    {
                        props.data.photo1 !== "photoAdult" && 
                        <Popup 
                            trigger={<button><img className="image1" src={require(`./photos/${props.data.photo1}`)} alt={`A ${props.data.name}`} onMouseEnter={() => setHighlighted("image")} onMouseLeave={() => setHighlighted("card")}/></button>}
                            position="right center" 
                            modal
                            contentStyle={{width: "65%", backgroundColor: "#E7E1DB"}}
                        >
                            <div className="popupImgContainer">
                                <img className="image1expand" src={require(`./photos/${props.data.photo1}`)} alt={`A ${props.data.name}`}/>
                            </div>
                            <ReactMarkdown className="imageCredit">
                                {"Photo Credit: " + props.data.photo1credit}
                            </ReactMarkdown>
                        </Popup>
                    }
                </div>
                <div className="names">
                    <h2 className="commonName">{props.data.name}</h2>
                    <h3 className="speciesName" >{props.data.species}</h3>
                </div>
            </div>
            <div style={{}} {...getCollapseProps()}>
                <div className="padding"></div>
                <div className="expandedContent">
                    {/* <p><span className="listKey">Status:</span> {threatened(props.data.threatStatus)}</p> */}
                    <p><span className="listKey">Diet:</span> {props.data.diet}</p>
                    <p><span className="listKey">Rarity:</span> {rarity(props.data.rarity)}</p>
                    <p><span className="listKey">Habitat:</span> {props.data.habitat}</p>
                    <p><span className="listKey">Description:</span> {props.data.description}</p>
                </div>
                <div className="padding"></div>
            </div>
        </div>
    );

}

/*
add this to getCollapseProps to change height
{style: {height: '200px'}}

*/